
import React from 'react'
import ReactDOM from 'react-dom'
// import MultiCrops from 'react-multi-crops'
import HotArea from './HotArea'
import { Row, Col } from '../basic';
import { Button, Upload, Icon, message, Input } from 'antd';
import * as  commonFunc from './HotAreaMapCommon';
import Container from './Container';
import { JSONParse } from './HotAreaMapCommon';
import SvgIcon from 'SvgIcon';

export class HotAreaMapDesign extends React.Component {

  /*   props:
  config:配置文件信息，如果传入空则为新增
  onSave ： 保存或者取消的函数
     */
  constructor(props) {
    super(props);
    let cStyle = (_.isEmpty(props.cStyle) || commonFunc.isDebug) ? commonFunc.getDebugCStyle(true) : props.cStyle;
    cStyle = commonFunc.JSONParse(cStyle);
    // cStyle = {
    //   codeField: "room_code",
    //   nameField: "room_name",
    //   fieldsCaption: "包房设置",
    //   mapConfigField: "hotzonediagram",
    //   refResetFields: ["room_roomType"]
    // };
    let tmpState = {};
    let fieldMapping = {};
    fieldMapping.codeField = cStyle.codeField || "";
    fieldMapping.nameField = cStyle.nameField || "";
    fieldMapping.stateField = cStyle.stateField || "";
    fieldMapping.captionFields = cStyle.captionFields || [];
    fieldMapping.mapConfigField = cStyle.mapConfigField || "";
    fieldMapping.fieldsCaption = cStyle.fieldsCaption || "";
    fieldMapping.refResetFields = cStyle.refResetFields || [];
    if (!fieldMapping.codeField || !fieldMapping.nameField || !fieldMapping.mapConfigField || !fieldMapping.fieldsCaption) {
      commonFunc.LogChartInfo(" 热区设置图 在CStyle中未能找到全部的热区配置字段 codeField nameField fieldsCaption mapConfigField ", 999);
    }
    tmpState.fieldMapping = fieldMapping;
    tmpState.extendClassName = cStyle.hasOwnProperty("extendClassName") ? cStyle.extendClassName : "";
    tmpState.triggerEvents = cStyle.triggerEvents;

    this.initMetaAndModel(fieldMapping.mapConfigField, fieldMapping.codeField, fieldMapping.nameField);

    tmpState.referReturnConfig = this.getReferReturnConfig();

    // let config = this.mapConfigFieldModel && this.mapConfigFieldModel.getValue();
    // config = config || commonFunc.getNullMapConfig();
    // tmpState.config = commonFunc.JSONParse(config);
    tmpState.config = commonFunc.getNullMapConfig();
    tmpState.selectedId = -1;
    this.state = tmpState;
  }

  initMetaAndModel(mapConfigField, codeField, nameField) {
    if (commonFunc.isDebug) {
      this.meta = this.props.meta;
      this.viewModel = this.props.viewModel;
      if (this.meta.controls.length > 1) {
        this.meta.controls = _.slice(this.meta.controls, 0, 1);
      }
    }
    else {
      this.meta = this.props.meta.containers[0];
      this.viewModel = this.props.model;
    }
    this.mapConfigFieldModel = this.viewModel.get(mapConfigField);
    this.codeFieldModel = this.viewModel.get(codeField);
    this.nameFieldModel = this.viewModel.get(nameField);
  }

  getReferReturnConfig() {
    let model = this.nameFieldModel;
    let referReturnConfig = {};
    if (model) {
      referReturnConfig.cControlType = model.get("cControlType");
      referReturnConfig.valueField = model.get("valueField");   // model.get("valueField") == billitem_base 表中的 refReturn
      referReturnConfig.textField = model.get("textField");   // model.get("textField") == billitem_base 表中的 displayname
      referReturnConfig.bEnum = model.get("bEnum");
      referReturnConfig.cDataSourceName = model.get("cDataSourceName");
      referReturnConfig.cFieldName = model.get("cFieldName");
      referReturnConfig.cItemName = model.get("cItemName");
      referReturnConfig.cRefType = model.get("cRefType");
      referReturnConfig.iFieldType = model.get("iFieldType");
      referReturnConfig.bCanModify = model.get("bCanModify");
    }
    return referReturnConfig;
  }

  setListenerState = (params) => {
  }
  componentDidMount() {
    let self = this;
    this.viewModel.on("beforeSave", (args) => this.beforeSave(args));
    this.viewModel.on('afterLoadData', data => {
      let config = self.mapConfigFieldModel && self.mapConfigFieldModel.getValue();
      if (!config) {
        config = commonFunc.getNullMapConfig();
      }
      config = commonFunc.JSONParse(config)
      self.setState({ config });
    });
    this.mapConfigFieldModel && this.mapConfigFieldModel.addListener(this);
    this.nameFieldModel && this.nameFieldModel.un("afterValueChange", this.setReferReturnData);
    this.nameFieldModel && this.nameFieldModel.on("afterValueChange", (args) => this.setReferReturnData(args));

    this.setDocumentServerAddress();
  }
  validate() {
    //  floor_hotzonediagram
    if (this.mapConfigFieldModel) {
      let str = JSON.stringify(this.state.config);
      this.mapConfigFieldModel.setValue(str);
    }
  }

  beforeSave(args) {

    let bFlag = this.checkMapConfig();

    return bFlag;

  }

  setDocumentServerAddress() {
    this.DocumentServerAddress = 'http://resourceyxy.yonyouup.com';
    var proxy = cb.rest.DynamicProxy.create({
      getFileServerUrl: {
        url: '/pub/fileupload/getFileServerUrl',
        method: 'GET',
        options: {
          token: true
        }
      }
    });
    proxy.getFileServerUrl({}, function (err, result) {
      if (!err)
        this.DocumentServerAddress = result;
    }, this);
  }
  // componentWillReceiveProps(nextProps) {
  //   if (_.isEqual(nextProps.config, this.props.config) == false) { }
  // }

  beforeUpload = (file) => {
    const isJPG = file.type === 'image/jpeg' || 'image/png';
    if (!isJPG) {
      message.error('目前只支持 JPG/PNG file!');
    }
    const isLt = file.size / 1024 / 1024 < 10;
    if (!isLt) {
      message.error('图片不可大于 10MB!');
    }
    return isJPG && isLt;
  }

  handleChange = (info) => {
    let self = this;
    if (info.file.status === 'done') {
      if (info.file.response.code == 200) {
        let imgUrl = this.DocumentServerAddress + info.file.response.data;
        // var img = new Image();
        // img.src = imgUrl;
        this.mapConfigValueChanged("imgUrl", imgUrl)
      }
      else {
        commonFunc.LogChartInfo(" 热区设置图 上传图片：调用服务出错  info.file.response " + JSON.stringify(info.file.response), 999);
      }
    }
  }
  doFunc = (funcName, params) => {
    if (funcName == "getHotAreaCaptionHtml") {
      {
        this.viewModel.execute("getHotAreaCaptionHtml", params);
        // params.areaHtml = "<div> " + params.coordinate.name + "</div>" + "<div> " + params.coordinate.refResetFields.room_roomType + "</div>"
      }
    }
  }
  changeCoordinate = (coordinate, index, coordinates) => {
    this.mapConfigValueChanged("coordinates", coordinates);
  }
  deleteCoordinate = (coordinate, index, coordinates) => {
    this.mapConfigValueChanged("coordinates", coordinates);
  }

  dragCoordinate = (coordinate, index, coordinates) => {
    this.mapConfigValueChanged("coordinates", coordinates);
  }

  selectArea = (coordinate) => {
    let selectedId = this.state.selectedId;
    if (selectedId != coordinate.id) {
      this.state.selectedId = coordinate.id;
      this.setState();
      this.codeFieldModel && this.codeFieldModel.setValue(coordinate.code, false);
      this.nameFieldModel && this.nameFieldModel.setValue(coordinate.name, false);
      this.state.fieldMapping.refResetFields.forEach((field) => {
        let tmpModel = this.viewModel.get(field);
        tmpModel && tmpModel.setValue(coordinate.refResetFields && coordinate.refResetFields[field], false);
      });
    }
  }
  ImgOnError = () => {
    console.log("加载图片错误。imgUrl = " + this.state.config.imgUrl || "");
    cb.utils.alert('加载图片错误。图片地址：' + this.state.config.imgUrl, 'error');
  }
  ImgOnLoad = (obj) => {
    let width = _.get(obj, "currentTarget.naturalWidth");
    let height = _.get(obj, "currentTarget.naturalHeight");
    if (width && height) {
      this.mapConfigValueChanged("width", width);
      this.mapConfigValueChanged("height", height);
    }
  }
  mapConfigValueChanged(name, value) {
    let config = this.state.config;
    config[name] = value;
    this.setState({ config });
  }

  areaConfigValueChanged(id, name, value) {
    let coordinates = this.state.config.coordinates;
    let obj = _.find(coordinates, function (o) { return o.id == id });
    if (obj) {
      obj[name] = value;
      this.mapConfigValueChanged("coordinates", coordinates);
    }
  }

  getTopPanel() {
    let panelArr = [];
    let bHasImg = !!this.state.config.imgUrl;

    if (bHasImg) {
      panelArr.push(<Button onClick={e => this.restoreConfig()}>
        <SvgIcon className="icon-delete" type="delete" />
        <div className={this.getClassName("ClearConfig")} >清除</div>
      </Button>);
      panelArr.push(<Upload
        showUploadList={false}
        action={'/upload?token=' + cb.rest.AppContext.token}
        beforeUpload={this.beforeUpload}
        onChange={this.handleChange}
        accept="image/jpeg,image/png"
      >
        <div>
          {/* <Icon type='uploadimg' /> */}
          <SvgIcon className="icon-edit" type="edit" />
          <div className={this.getClassName("ReplaceImg")} >替换图片</div>
        </div>
      </Upload>);
    }
    else {
      panelArr.push(<div className={this.getClassName("Upload_Outer")} >
        <Upload
          showUploadList={false}
          action={'/upload?token=' + cb.rest.AppContext.token}
          beforeUpload={this.beforeUpload}
          onChange={this.handleChange}
          accept="image/jpeg,image/png"
        >
          <div className={this.getClassName("UploadImg")}>
            <Icon type='uploadimg' />
            <p>点击上传背景图片</p>
          </div>
        </Upload>
      </div >);
      panelArr.push(<div className={this.getClassName("Upload_Text")}>支持上传10M以下png/jpg格式的图片</div>);
    }
    return <div className={this.getClassName("TopPanel" + (bHasImg ? "_HasImg" : "_NoImg"))}>  {panelArr} </div>;

  }
  getLeftPanel() {
    let areaArr = this.getAreaArr();

    let coordinate = this.getSelectedCoordinate();
    let triggerEvents = this.state.triggerEvents;
    let panelArr = [];
    if (commonFunc.isDebug) {
      panelArr.push(<div>ID:{coordinate && coordinate.id}</div>);
      panelArr.push(<div>Code:{coordinate && coordinate.code}</div>)
    }
    // panelArr.push(<div> {this.state.fieldMapping.fieldsCaption}</div>);
    if (triggerEvents && (triggerEvents.click == "url" || triggerEvents.doubleClick == "url")) {
      panelArr.push(<div>URL</div>);
      panelArr.push(<div>
        <Input
          value={coordinate && coordinate.url}
          onChange={(e) => this.areaConfigValueChanged(coordinate.id, "url", e.target.value)}
        />
      </div>);
    }
    panelArr.push(<div className={this.getClassName("AreaArr-Outer")}   >{areaArr}</div>);
    // panelArr.push(<div>
    //   <Button onClick={e => this.saveConfig(false)}>取消</Button>
    //   <Button onClick={e => this.saveConfig(true)}>确定</Button>
    // </div>);
    let tmp = <div className={this.getClassName("LeftPanel")}>  {panelArr} </div>;
    return tmp;
  }
  // getAreaArr() {
  //   let arr = [];
  //   let editFields = this.state.editFields;
  //   editFields.forEach(
  //     (item, index) => {

  //       let bCanModify = item.bCanModify;// true
  //       let bEnum = item.bEnum;// false
  //       let bHidden = item.bHidden;// false
  //       let bIsNull = item.bIsNull;//true
  //       let cCaption = item.cCaption;// "门店编码"
  //       let cControlType = item.cControlType;// "Input"
  //       let cDataSourceName = item.cDataSourceName;// "aa.store.Store"
  //       let cFieldName = item.cFieldName;// "codebianma"
  //       let cItemName = item.cItemName;// "codebianma"
  //       let cName = item.cName;// "codebianma"
  //       let cShowCaption = item.cShowCaption;// "门店编码"
  //       let iFieldType = item.iFieldType;// 1
  //       arr.push(<Row colCount={12} >
  //         <span span={4}>{cShowCaption}</span>

  //         <span span={8}>
  //           <Input
  //             value={cShowCaption}
  //             style={{ width: 60 }}
  //             onChange={(e) => this.areaFieldValueChanged(cFieldName, e.target.value)}
  //           />
  //         </span>

  //       </Row>)
  //     }
  //   );
  //   return arr;
  // }
  // getLeftPanel() {
  //   let areaArr = this.getAreaArr();
  //   let upLoad = this.getUpLoad();
  //   let tmp = <div>
  //     <Row colCount={12} >
  //       <span span={2}>名称:</span>
  //       <span span={10}>
  //         <Input
  //           value={this.state.config.name}
  //           style={{ width: 60 }}
  //           onChange={(e) => this.mapConfigValueChanged("name", e.target.value)}
  //         />
  //       </span>
  //     </Row>
  //     <Row>{upLoad}</Row>
  //     <Row>{areaArr}</Row>
  //     <Row>
  //       <Button onClick={e => this.saveConfig(false)}>取消</Button>
  //       <Button onClick={e => this.saveConfig(true)}>确定</Button>
  //     </Row>
  //   </div>;
  //   return tmp;
  // }
  // getAreaArr() {
  //   let arr = [];
  //   this.state.config.coordinates.forEach(
  //     (item, index) => {
  //       arr.push(<Row colCount={12} >
  //         <span span={1}>序号:</span>
  //         <span span={1}>{index + 1}</span>
  //         <span span={2}>编码:</span>
  //         <span span={3}>
  //           <Input
  //             value={item.code}
  //             style={{ width: 60 }}
  //             onChange={(e) => this.areaConfigValueChanged(item.id, "code", e.target.value)}
  //           />
  //         </span>
  //         <span span={2}>名称:</span>
  //         <span span={3}>
  //           <Input
  //             value={item.name}
  //             style={{ width: 80 }}
  //             onChange={(e) => this.areaConfigValueChanged(item.id, "name", e.target.value)}
  //           />
  //         </span>
  //       </Row>)
  //     }
  //   );
  //   return arr;
  // }
  coordinatesHasErr(coordinates) {
    // let newCoordinates = _.remove(coordinates, function (o) {
    //   return o.width > 5 && o.height > 5;
    // });
    // this.mapConfigValueChanged("coordinates", newCoordinates);
    let codeArr = [];
    let repeatedCode = [];
    coordinates.forEach((ele) => {
      if (codeArr.indexOf(ele.code) >= 0) {
        if (repeatedCode.indexOf(ele.code) < 0) {
          repeatedCode.push(ele.code);
        }
      }
      else {
        codeArr.push(ele.code);
      }
    })
    if (repeatedCode.length > 0) {
      cb.utils.alert('存在编码重复的区域：' + repeatedCode.join(","), 'error');
      return true;
    }
    else {
      return false;
    }
  }

  checkMapConfig() {
    let config = this.state.config;
    let tmp = false;
    // if (!config.name) {
    //   cb.utils.alert('楼层图名称不可为空', 'error');
    // }
    // else
    if (!config.imgUrl) {
      cb.utils.alert('背景图片不可为空', 'error');
    }
    else if (_.filter(config.coordinates, function (ele) { return !ele.code }).length > 0) {
      cb.utils.alert('不能存在编码为空的区域。', 'error');
    }
    else if (this.coordinatesHasErr(config.coordinates) == true) {

    }
    else {
      tmp = true;
    }
    return tmp;
  }

  restoreConfig() {
    this.setState({
      config: commonFunc.getNullMapConfig(),
      selectedId: -1
    });
  }
  // saveConfig(bOk) {
  //   if ((bOk == true && this.checkMapConfig() == true) || (bOk == false)) {
  //     this.props.onSave && this.props.onSave(bOk, this.state.config);
  //     this.props.close && this.props.close();
  //   }
  // }
  getSelectedCoordinate() {
    let self = this;
    return _.find(this.state.config.coordinates, function (o) { return o.id == self.state.selectedId });
  }
  getClassName(str) {
    let className = " HotAreaMapDesign_" + str;
    if (!!this.state.extendClassName) {
      className = className + " " + this.state.extendClassName + "HotAreaMapDesign_" + str
    }
    return className;
  }

  render() {
    let self = this;
    let isReadOnly = (_.get(this.viewModel, "originalParams.mode") == "browse" ? true : false);
    let leftPanel = this.getLeftPanel();
    let topPanel;
    if (isReadOnly == false) {
      topPanel = this.getTopPanel();
    }
    let style = {};
    let areaPanel;
    if (_.isEmpty(this.state.config.imgUrl) == false) {
      areaPanel = <HotArea // ref={node => this.refNode = node}
        //<img src={logoImg}
        // src={"http://resourceyxy.yonyouup.com/5d711f7d-dc14-4f78-ac4e-40fea5fe4f0d.png"}
        src={this.state.config.imgUrl}
        width={this.state.config.width}
        height={this.state.config.height}
        coordinates={this.state.config.coordinates}
        onChange={this.changeCoordinate}
        onDelete={this.deleteCoordinate}
        onDrag={this.dragCoordinate}
        onLoad={this.ImgOnLoad}
        onError={this.ImgOnError}
        selectArea={this.selectArea}
        extendClassName={this.state.extendClassName}
        isReadOnly={isReadOnly}
        doFunc={this.doFunc}
      />;
    }
    // style.width = (this.props.width || 800) - 20;
    // style.height = (this.props.height || 600) - 20;
    // if (this.state.config.width && (this.state.config.width / 9 + 10) > (style.width / 12)) {
    //   style.width = this.state.config.width / 9 * 12 + 10;
    // }
    // if (this.state.config.height && this.state.config.height > style.height)
    //   style.height = this.state.config.height;
    let className = this.getClassName("MapOuter") + (isReadOnly ? this.getClassName("MapOuter_ReadOnly") : "");
    let bHasImg = !!this.state.config.imgUrl;
    let height = bHasImg ? (this.state.config.height + 55) : undefined;
    return <div style={style} className={className} >
      <div className={this.getClassName("Map")}>
        <div className={this.getClassName("Row")}   >
          <div className={this.getClassName("LeftPanel_Outer")} >
            {leftPanel}
          </div>
          <div
            style={{ height: height }}
            className={this.getClassName("HotArea_Outer")}
          >
            {topPanel}
            {areaPanel}
            <div className={this.getClassName("ZhanWei")} ></div>
          </div>
        </div>
      </div>
    </div >;
  }


  getAreaArr() {
    let obj;
    let self = this;
    // let container = this.props.container;
    if (self.meta) {
      obj = <Container
        className={(self.state.extendClassName || "") + "HotAreaMapDesign_Container"}
        meta={self.meta}
        viewModel={self.viewModel}
        // width={100}
        // height={700}
        index={1}
      />;
    }
    return <div className={this.getClassName("AreaArr-Inner")}> {obj}</div>;

  }



  setReferReturnData(args) {
    let self = this;
    let coordinates = self.state.config.coordinates;
    let coordinate = this.getSelectedCoordinate();
    if (coordinate && _.isEmpty(args.obj) == false) {
      coordinate.code = "";
      coordinate.name = "";

      coordinate.code = this.codeFieldModel && this.codeFieldModel.getValue();
      coordinate.name = this.nameFieldModel && this.nameFieldModel.getValue();
      coordinate.refResetFields = {};
      self.state.fieldMapping.refResetFields.forEach((field) => {
        let tmpModel = this.viewModel.get(field);
        coordinate.refResetFields[field] = tmpModel && tmpModel.getValue();
      });
      self.setState({ coordinates });
    }
  }
  // setReferReturnData(args) {
  //   let self = this;
  //   let referReturnConfig = this.state.referReturnConfig;
  //   let cControlType = referReturnConfig.cControlType && referReturnConfig.cControlType.toLocaleLowerCase();
  //   let coordinates = self.state.config.coordinates;
  //   let coordinate = this.getSelectedCoordinate();
  //   if (coordinate) {
  //     if (cControlType == "treerefer" || cControlType == "refer") {
  //       let obj = args.obj;
  //       if (obj && _.isEmpty(obj.select) == false) {
  //         coordinate.code = "";
  //         coordinate.showName = "";
  //         coordinate.name = "";
  //         if (commonFunc.isDebug) {
  //           coordinate.code = obj.select.code;
  //         }
  //         else {
  //           coordinate.code = obj.value;
  //         }
  //         coordinate.showName = obj.text;

  //         let nameField = this.state.cStyle.nameField;
  //         if (nameField) {
  //           coordinate.name = obj.select && obj.select[nameField];
  //         }
  //       }
  //     }
  //     else if (cControlType == "input") {
  //       coordinate.code = args.value;
  //     }
  //     self.setState({ coordinates });
  //   }
  // }
};
export default HotAreaMapDesign





// WEBPACK FOOTER //
// ./src/yxyweb/common/components/meta/HotAreaMapDesign.jsx